<template>
    <div>
        <div v-if="!isLoading" class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.nameCampaign') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <Multiselect
                            v-show="!basicForm?.id"
                            :id="`select-campaign-for-landing-page`"
                            :value.sync="basicForm.campaign"
                            :options="listDataMasterCampaign"
                            :config.sync="configForm.configFieldSelectCampaign"
                            @select="getDetailCampaignForLP"
                            @remove="handleValidateField(configForm.configFieldSelectCampaign)"
                        />
                        <span v-if="basicForm?.id"> {{ basicForm.campaign?.name }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.idLP') }} </label>
                    <div class="col-sm-10">
                        {{ basicForm?.code ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.nameLandingPage') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="basicForm.name"
                            :config.sync="configForm.configFieldNameLandingPage"
                            @blur="handleValidateField(configForm.configFieldNameLandingPage)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.numberCP') }} </label>
                    <div class="col-sm-10">
                        {{ basicForm?.number_cp ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.businessAssistant') }} </label>
                    <div class="col-sm-10">
                        <Multiselect
                            :id="`select-sale_staff`"
                            :value.sync="basicForm.sale_staff"
                            :options="listDataMasterSaleEmploy"
                            :config.sync="configForm.configFieldSaleStaff"
                            @remove="handleValidateField(configForm.configFieldSaleStaff)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.picInstructions') }} </label>
                    <div class="col-sm-10">
                        <Multiselect
                            :id="`select-person_in_charge`"
                            :value.sync="basicForm.person_in_charge"
                            :options="listDataMasterInstructorStaf"
                            :config.sync="configForm.configFieldPICinstructions"
                            @remove="handleValidateField(configForm.configFieldPICinstructions)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.ZACID') }} </label>
                    <div class="col-sm-10">
                        {{ basicForm?.zac_id ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.SFID') }} </label>
                    <div class="col-sm-10">
                        {{ basicForm?.sfid ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.campaignEntityId') }} </label>
                    <div class="col-sm-10">
                        {{ basicForm?.campaign_entity_id ?? '' }}
                    </div>
                </div>
                <div>
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                            >{{ $t('landingPage.settingBasic.publicationStarts') }}
                            <span v-if="onHandleCheckFieldRequired(configForm.configFieldPublicationStartDateTime.typesValidate)" class="text-danger"
                                >*</span
                            ></label
                        >
                        <div class="col-sm-10">
                            <DateTime
                                id="select-publication-starts-date-time"
                                :full_date.sync="basicForm.publication_start_date"
                                :full_time.sync="basicForm.publication_start_time"
                                :config.sync="configForm.configFieldPublicationStartDateTime"
                                @blur="
                                    handleValidateField(
                                        configForm.configFieldPublicationStartDateTime,
                                        ['compare-date'],
                                        ['configFieldPublicationStartDateTime', 'configFieldPublicationEndDateTime']
                                    )
                                "
                            >
                                <span
                                    v-if="
                                        configForm.configFieldPublicationStartDateTime.error &&
                                        configForm.configFieldPublicationStartDateTime.isShowMessCustom
                                    "
                                    class="invalid-feedback d-block"
                                    >{{ configForm.configFieldPublicationStartDateTime.errorText }}</span
                                >
                            </DateTime>
                            <div class="mt-1">
                                <span style="font-size: 12px">{{ $t('landingPage.settingBasic.notePublicationStarts') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                            >{{ $t('landingPage.settingBasic.publicationEnds') }}
                            <span v-if="onHandleCheckFieldRequired(configForm.configFieldPublicationEndDateTime.typesValidate)" class="text-danger"
                                >*</span
                            ></label
                        >
                        <div class="col-sm-10">
                            <DateTime
                                id="select-publication-ends-date-time"
                                :full_date.sync="basicForm.publication_end_date"
                                :full_time.sync="basicForm.publication_end_time"
                                :config.sync="configForm.configFieldPublicationEndDateTime"
                                @blur="
                                    handleValidateField(
                                        configForm.configFieldPublicationEndDateTime,
                                        ['compare-date', 'range-before-date'],
                                        ['configFieldPublicationStartDateTime', 'configFieldPublicationEndDateTime', 'configFieldLPStartDateTime']
                                    )
                                "
                            >
                                <span
                                    v-if="
                                        configForm.configFieldPublicationEndDateTime.error &&
                                        configForm.configFieldPublicationEndDateTime.isShowMessCustom
                                    "
                                    class="invalid-feedback d-block"
                                    >{{ configForm.configFieldPublicationEndDateTime.errorText }}</span
                                >
                            </DateTime>
                            <div class="mt-1">
                                <span style="font-size: 12px">{{ $t('landingPage.settingBasic.notePublicationEnds') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.landingPageStartDate') }}
                        <span v-if="onHandleCheckFieldRequired(configForm.configFieldLPStartDateTime.typesValidate)" class="text-danger">*</span>
                    </label>
                    <div class="col-sm-10">
                        <DateTime
                            id="select-lp-start-date-time"
                            :full_date.sync="basicForm.lp_start_date"
                            :full_time.sync="basicForm.lp_start_time"
                            :config.sync="configForm.configFieldLPStartDateTime"
                            @blur="handleValidateField(configForm.configFieldLPStartDateTime)"
                        >
                            <span v-if="configForm.configFieldLPStartDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldLPStartDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.campaignStartDate') }}
                        <span v-if="onHandleCheckFieldRequired(configForm.configFieldLPStartDateTime.typesValidate)" class="text-danger"
                            >*</span
                        ></label
                    >
                    <div class="col-sm-10">
                        <DateTime
                            id="select-campaign-start-date-time"
                            :full_date.sync="basicForm.campaign_start_date"
                            :full_time.sync="basicForm.campaign_start_time"
                            :config.sync="configForm.configFieldCampaignStartDateTime"
                            @blur="
                                handleValidateField(
                                    configForm.configFieldCampaignStartDateTime,
                                    ['compare-date'],
                                    ['configFieldLPStartDateTime', 'configFieldCampaignStartDateTime']
                                )
                            "
                        >
                            <span v-if="configForm.configFieldCampaignStartDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldCampaignStartDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.campaignEndDate') }}
                        <span v-if="onHandleCheckFieldRequired(configForm.configFieldLPStartDateTime.typesValidate)" class="text-danger">*</span>
                    </label>
                    <div class="col-sm-10">
                        <DateTime
                            id="select-campaign-end-date-time"
                            :full_date.sync="basicForm.campaign_end_date"
                            :full_time.sync="basicForm.campaign_end_time"
                            :config.sync="configForm.configFieldCampaignEndDateTime"
                            @blur="
                                handleValidateField(
                                    configForm.configFieldCampaignEndDateTime,
                                    ['compare-date'],
                                    ['configFieldCampaignStartDateTime', 'configFieldCampaignEndDateTime']
                                )
                            "
                        >
                            <span style="font-size: 12px">{{ $t('landingPage.settingBasic.noteTimeEndCampaign') }}</span>
                            <span v-if="configForm.configFieldCampaignEndDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldCampaignEndDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.landingPageEndDate') }}
                        <span v-if="onHandleCheckFieldRequired(configForm.configFieldLPStartDateTime.typesValidate)" class="text-danger"
                            >*</span
                        ></label
                    >
                    <div class="col-sm-10">
                        <DateTime
                            id="select-lp-end-date-time"
                            :full_date.sync="basicForm.lp_end_date"
                            :full_time.sync="basicForm.lp_end_time"
                            :config.sync="configForm.configFieldLPEndDateTime"
                            @blur="
                                handleValidateField(
                                    configForm.configFieldLPEndDateTime,
                                    ['compare-date'],
                                    ['configFieldCampaignEndDateTime', 'configFieldLPEndDateTime']
                                )
                            "
                        >
                            <span style="font-size: 12px">{{ $t('landingPage.settingBasic.noteTimeEndLandingPage') }}</span>
                            <span v-if="configForm.configFieldLPEndDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldLPEndDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.status') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap">
                            <div v-for="item in STATUS_SETTING_BASIC" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="basicForm.status"
                                    :name="`status_basic_setting`"
                                    :id="`status_basic_setting-${item.id}`"
                                    :value="item.id"
                                    :label="item.value"
                                    :disabled="basicForm.automatic_status_update"
                                    :config="{
                                        classCustomLabel: basicForm.status === item.id ? 'status__active--lading-page' : '',
                                        error: false
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.basicAuthen') }} </label>
                    <div class="col-sm-10">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 100px"
                                >{{ $t('landingPage.userName') }} <span class="text-danger">*</span></label
                            >
                            <div class="col-sm-4">
                                <InputText
                                    :model.sync="basicForm.landing_page_user.username"
                                    :config.sync="configForm.configFieldEmailLP"
                                    @blur="handleValidateField(configForm.configFieldEmailLP)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 100px"
                                >{{ $t('landingPage.password') }} <span class="text-danger">*</span></label
                            >
                            <div class="col-sm-4">
                                <div class="position-relative">
                                    <InputText
                                        :model.sync="basicForm.landing_page_user.password"
                                        :config.sync="configForm.configFieldPassLP"
                                        @blur="handleValidateField(configForm.configFieldPassLP)"
                                    />
                                    <span
                                        class="position-absolute btn"
                                        style="top: 0; right: 0px; padding: 3px; line-height: 2"
                                        @click="handleTriggerPass"
                                    >
                                        <i :class="iconEye" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.statusAuto') }} </label>
                    <div class="col-sm-10">
                        <InputCheckBox
                            :model.sync="basicForm.automatic_status_update"
                            :id="`check-auto-status`"
                            :value="basicForm.automatic_status_update"
                            :label="``"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.meta') }} </label>
                    <div class="col-sm-10">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.keyword') }} </label>
                            <div class="col-sm-10">
                                <KeyWordTag2
                                    :id="`tag-keywords`"
                                    :model.sync="basicForm.keywords"
                                    :config.sync="configForm.configFieldKeywordSite"
                                    @blur="handleValidateField(configForm.configFieldKeywordSite)"
                                >
                                    <span v-if="configForm.configFieldKeywordSite.error">
                                        {{ configForm.configFieldKeywordSite.errorCustomMess }}
                                    </span>
                                </KeyWordTag2>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.description') }} </label>
                            <div class="col-sm-10">
                                <InputText
                                    :model.sync="basicForm.description"
                                    :config.sync="configForm.configFieldDescriptions"
                                    @blur="handleValidateField(configForm.configFieldDescriptions)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.analytics') }} </label>
                    <div class="col-sm-10">
                        <textarea rows="2" v-model="basicForm.analytics" class="form-control"></textarea>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.headSource') }} </label>
                    <div class="col-sm-10">
                        <textarea rows="6" v-model="basicForm.head_source" class="form-control"></textarea>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.bodyDirectlyBelow') }} </label>
                    <div class="col-sm-10">
                        <textarea rows="6" v-model="basicForm.body_directly_below" class="form-control"></textarea>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px"
                        >{{ $t('landingPage.settingBasic.urlPublic') }}
                        <span class="text-danger">*</span>
                        <div class="mt-1">
                            <span>{{ $t('landingPage.settingBasic.desUrlPublic') }}</span>
                        </div>
                    </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap align-items-center">
                            <Multiselect
                                v-if="listCustomDomains.length > 0"
                                class="mr-2 mt-3"
                                style="max-width: 250px"
                                :options="listCustomDomains"
                                :value.sync="selectedCustomDomain"
                                :config="{
                                    label: 'domain',
                                    trackBy: 'id',
                                    placeholder: '',
                                    searchable: true,
                                    error: false,
                                    isRemove: false
                                }"
                            />
                            <span class="mr-1 mt-3" style="line-height: 0.5">/landing-page/</span>
                            <InputText
                                class="mt-3"
                                :model.sync="basicForm.url_public"
                                :config.sync="configForm.configFieldUrlPublic"
                                @blur="handleValidateField(configForm.configFieldUrlPublic)"
                            />
                        </div>
                        <span>{{ $t('landingPage.settingBasic.noteUrlPublic') }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingBasic.ogImage') }} </label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="basicForm.og_image"
                            :id="`ImageOG`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>
            </form>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputRadio, InputCheckBox } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { STATUS_SETTING_BASIC, STT_HAS_BASIC_AUTH } from '../../constants';
import { handleMapDataFromStateLP, validateEndDate, validateRangeDate } from '../../handlers';
import { IMAGE_EXTENSIONS } from '@/utils/format';
import { masterMethods, landingPageMethods } from '@/state/helpers';
import { cloneDeep } from 'lodash';
import { onHandleCheckFieldRequired, getInfoUserLocalStorage } from '@/utils/handlers';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import { managerFormMethods } from '@/state/helpers';

import KeyWordTag2 from '@/components/KeywordTag/main2.vue';
import DateTime from '@/components/DateCustoms/DateTime/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

export default {
    name: 'SettingBasicLP',
    components: {
        InputText,
        DateTime,
        InputRadio,
        InputCheckBox,
        KeyWordTag2,
        UploadImageCommon,
        Multiselect,
        LoadingIcon
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        listCommon: {
            type: Object,
            required: true,
            default: () => {}
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['allInforCampaignLP'])
        })
    },
    data() {
        return {
            STATUS_SETTING_BASIC: STATUS_SETTING_BASIC,
            arrExtension: IMAGE_EXTENSIONS,
            listDataMasterCampaign: [],
            listDataMasterSaleEmploy: [],
            listDataMasterInstructorStaf: [],
            configRequireDateTime: ['dateTime', 'requiredDate'],
            configNotRequireDate: ['dateTime'],
            sttBasicAuth: STT_HAS_BASIC_AUTH,
            isLoading: false,
            basicForm: cloneDeep(this.dataForm),
            iconEye: 'fa fa-eye-slash',
            listCustomDomains: [],
            selectedCustomDomain: null
        };
    },
    methods: {
        ...masterMethods,
        ...landingPageMethods,
        ...managerFormMethods,
        onHandleCheckFieldRequired,

        handleValidateField(configField, action = [], configValidate = []) {
            validateField(configField);
            if (action.includes('compare-date')) {
                validateEndDate(this.configForm[configValidate[0]], this.configForm[configValidate[1]]);
            }
            if (action.includes('range-before-date')) {
                validateRangeDate(this.configForm[configValidate[0]], this.configForm[configValidate[1]], this.configForm[configValidate[2]]);
            }
        },

        async getMasterCampaign() {
            this.isLoading = true;
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        getListMasterInstructorStaf(listCustomerTeam, listUserFilterRole) {
            let arrTwoInstructorStaf = [...listUserFilterRole, ...listCustomerTeam];
            this.listDataMasterInstructorStaf = arrTwoInstructorStaf.reduce((acc, current) => {
                const x = acc.find((item) => item.id === current.id);
                if (!x) {
                    acc.push(current);
                }
                return acc;
            }, []);
        },

        async getDetailCampaignForLP() {
            try {
                await this.getDetailCampaignForLandingPage(this.basicForm.campaign.id);
                handleMapDataFromStateLP(this.basicForm, this.allInforCampaignLP);
            } catch (error) {
                console.log('error', error);
            }
        },

        handleTriggerPass() {
            let { configFieldPassLP } = this.configForm;
            if (configFieldPassLP.type == 'password') {
                configFieldPassLP.type = 'text';
                this.iconEye = 'fa fa-eye';
            } else {
                configFieldPassLP.type = 'password';
                this.iconEye = 'fa fa-eye-slash';
            }
        },
        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                let defaultDomainStr = process.env.VUE_APP_DOMAIN_LP || '';
                defaultDomainStr = defaultDomainStr.replace(/^https?:\/\//, '');
                let defaultDomain = {
                    id: null,
                    domain: defaultDomainStr
                };
                let customDomains = [];
                if (response?.data) {
                    customDomains = response.data;
                }

                this.listCustomDomains = [defaultDomain, ...customDomains];

                if (this.basicForm.custom_domain_id) {
                    this.selectedCustomDomain =
                        this.listCustomDomains.find((item) => item.id === this.basicForm.custom_domain_id) ||
                        (this.basicForm.custom_domain?.id === this.basicForm.custom_domain_id ? this.basicForm.custom_domain : defaultDomain);
                } else {
                    this.selectedCustomDomain = defaultDomain;
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    watch: {
        listCommon: {
            handler: function (newList) {
                let { listCustomerTeam, listDataMasterSaleEmploy, listUserFilterRole } = newList;
                this.listDataMasterSaleEmploy = listDataMasterSaleEmploy || [];
                this.listUserFilterRole = listUserFilterRole || [];
                this.listCustomerTeam = listCustomerTeam || [];
                this.getListMasterInstructorStaf(this.listCustomerTeam, this.listUserFilterRole);
            },
            immediate: true
        },

        dataForm: {
            handler(newDataForm) {
                this.basicForm = newDataForm;
            },
            deep: true
        },

        basicForm: {
            handler(newBasicForm) {
                this.$emit('update:dataForm', newBasicForm);
                if (this.listCustomDomains.length > 0) {
                    if (newBasicForm.custom_domain_id) {
                        if (!this.selectedCustomDomain || this.selectedCustomDomain.id !== newBasicForm.custom_domain_id) {
                            this.selectedCustomDomain =
                                this.listCustomDomains.find((item) => item.id === newBasicForm.custom_domain_id) ||
                                (this.basicForm.custom_domain?.id === newBasicForm.custom_domain_id ? this.basicForm.custom_domain : null);
                        }
                    } else {
                        if (!this.selectedCustomDomain || this.selectedCustomDomain.id !== null) {
                            this.selectedCustomDomain = this.listCustomDomains.find((item) => item.id === null) || null;
                        }
                    }
                }
            },
            deep: true
        },
        selectedCustomDomain(newVal) {
            this.basicForm.custom_domain_id = newVal ? newVal.id : null;
        }
    },
    mounted() {
        this.onGetListCustomDomain();
        this.handleTriggerPass();
        if (this.basicForm.campaign?.id && !this.$route?.query?.id) {
            this.getDetailCampaignForLP();
        }

        if (!this.$route?.query?.id) {
            this.getMasterCampaign();
        }
    }
};
</script>

<style lang="scss" scoped></style>

<style>
.status__active--lading-page {
    background-color: gray;
    padding: 6px 20px;
    color: #fff !important;
    border-radius: 10px;
    line-height: 1;
}
</style>
